



























































































































































































































































































































import Vue from 'vue';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';
import { authMixin } from '@/mixins/auth';

import DropdownOption from '@/models/misc/DropdownOption';
import { TlQuoteEmailCommodity } from '@/models/tl-quote-email/TlQuoteEmailCommodity';
import ProductList from '@/components/shared/shipments/popups/ProductList.vue';

import equipmentTypeService from '@/services/EquipmentTypeService';
import hazmatService from '@/services/HazmatService';


export default Vue.extend<any, any, any, any>({
    name: 'truck-quote-commodity-information',
    mixins: [breakpointsMixin, iconsMixin, authMixin],
    props: {
        value: {
            type: Array as () => TlQuoteEmailCommodity[],
            required: true
        },
        showError: {
            type: Boolean,
            default: false
        },
        missingFields: {
            type: Array as () => string[],
            default: () => []
        },
        equipmentType: {
            type: String,
            default: null
        },
        equipmentTypesDdl: {
            type: Array,
            required: true
        },
        validateBlock: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ProductList
    },
    data() {
        return {
            localEquipmentType: this.equipmentType,
            localEquipmentTypesDdl: [] as DropdownOption[],
            commodityForm: {
                name: '',
                pieces: null,
                weight: null,
                weightUnit: 'lbs',
                length: null,
                width: null,
                height: null,
                dimensionUnit: 'in',
            } as TlQuoteEmailCommodity,
            validateCommodityForm: true,
            validationEnabledForCommodities: false,
            isResettingForm: false,
            formResetKey: 0,
            showEditModal: false,
            editFormCommodity: {
                name: '',
                pieces: null,
                weight: null,
                weightUnit: 'lbs',
                length: null,
                width: null,
                height: null,
                dimensionUnit: 'in',
                isHazmat: false,
                hazmatQty: null,
                hazmatClass: null,
                packingGroup: null,
                hazmatCode: '',
                hazmatContactName: '',
                hazmatContactPhone: ''
            } as TlQuoteEmailCommodity,
            editingCommodityIndex: null as number | null,
            editMissingFields: [] as string[],
            showEditCommodityError: false,
            showDeleteConfirmDialog: false,
            commodityToDeleteIndex: null as number | null,
            showProductListPopup: false,
            serviceInfo: {
                isHazmat: false,
                hazmatQty: null,
                hazmatClass: null,
                packingGroup: null,
                hazmatCode: '',
                hazmatContactName: '',
                hazmatContactPhone: ''
            },
            hazmatClasses: [],
            hazmatQtyTypes: [],
            packingGroupTypes: [],
        };
    },
    computed: {
        commodities: {
            get(): TlQuoteEmailCommodity[] {
                return this.value;
            },
            set(value: TlQuoteEmailCommodity[]) {
                this.$emit('input', value);
            }
        }
    },
    created() {
        this.localEquipmentTypesDdl = [...this.equipmentTypesDdl];
        // fetch equipment types
        equipmentTypeService.search(this.user.accountId, this.user.userId, 6)
            .then(response => {
                this.localEquipmentTypesDdl = response.map(type => new DropdownOption(type.description, type.id));
            })
            .catch(error => {
                console.error('Error fetching equipment types:', error);
            });

        // fetch hazmat dropdowns
        this.loadHazmatDropdowns();
    },
    watch: {
        'commodityForm': {
            handler() {
                if (this.validationEnabledForCommodities && !this.isResettingForm) {
                    this.handleCommodityFormChange();
                }
            },
            deep: true
        },
        'editFormCommodity': {
            handler(newVal) {
                if (this.showEditCommodityError) {
                    this.validateEditForm();
                }
            },
            deep: true
        },
        'serviceInfo.isHazmat': function (newVal) {
            if (newVal) {
                this.validateHazmatDetails();
            }
        }
    },
    methods: {
        validateCommodityBlock(): boolean {
            const missingFields: string[] = [];

            if (!this.localEquipmentType) {
                missingFields.push('Equipment Type');
            }
            if (this.commodities.length === 0) {
                missingFields.push('At least one commodity must be added');
            }

            this.$emit('update:missingFields', missingFields);
            this.$emit('update:showError', missingFields.length > 0);

            return missingFields.length === 0;
        },
        validateForm(): boolean {
            const c = this.commodityForm;
            const missingFields: string[] = [];

            if (!c.name) missingFields.push('Name');
            if (!c.pieces) missingFields.push('Number of Pieces');
            if (!c.weight) missingFields.push('Weight');
            if (!c.length) missingFields.push('Length');
            if (!c.width) missingFields.push('Width');
            if (!c.height) missingFields.push('Height');

            return missingFields.length === 0;
        },
        validateEditForm(): boolean {
            const c = this.editFormCommodity;
            const missingFields: string[] = [];

            if (!c.name) missingFields.push('Name');
            if (!c.pieces) missingFields.push('Number of Pieces');
            if (!c.weight) missingFields.push('Weight');
            if (!c.length) missingFields.push('Length');
            if (!c.width) missingFields.push('Width');
            if (!c.height) missingFields.push('Height');

            // Validate hazmat fields if isHazmat is true
            if (c.isHazmat) {
                if (!c.hazmatQty) missingFields.push('Hazmat Quantity');
                if (!c.hazmatClass) missingFields.push('Hazmat Class');
                if (!c.packingGroup) missingFields.push('Package Group');
                if (!c.hazmatCode) missingFields.push('Hazmat Code');
                if (!c.hazmatContactName) missingFields.push('Contact Name');
                if (!c.hazmatContactPhone) missingFields.push('Contact Phone');
            }

            this.editMissingFields = missingFields;
            this.showEditCommodityError = missingFields.length > 0;
            return missingFields.length === 0;
        },
        handleCommodityFormChange(): void {
            if (this.validationEnabledForCommodities) {
                const missingFields: string[] = [];

                if (!this.commodityForm.name) missingFields.push('Name');
                if (!this.commodityForm.pieces) missingFields.push('Number of Pieces');
                if (!this.commodityForm.weight) missingFields.push('Weight');
                if (!this.commodityForm.length) missingFields.push('Length');
                if (!this.commodityForm.width) missingFields.push('Width');
                if (!this.commodityForm.height) missingFields.push('Height');

                const isValid = missingFields.length === 0;
                this.$emit('update:missingFields', missingFields);
                this.$emit('update:showError', !isValid);
            }
        },
        addCommodity(): void {
            this.validationEnabledForCommodities = true;

            const isValid = this.validateForm();

            if (this.serviceInfo.isHazmat) {
                const hazmatValid = this.validateHazmatDetails();
                if (!hazmatValid) {
                    return;
                }
            }

            if (!isValid) {
                const missingFields: string[] = [];

                if (!this.commodityForm.name) missingFields.push('Name');
                if (!this.commodityForm.pieces) missingFields.push('Number of Pieces');
                if (!this.commodityForm.weight) missingFields.push('Weight');
                if (!this.commodityForm.length) missingFields.push('Length');
                if (!this.commodityForm.width) missingFields.push('Width');
                if (!this.commodityForm.height) missingFields.push('Height');

                this.$emit('update:missingFields', missingFields);
                this.$emit('update:showError', true);
                return;
            }

            const newCommodities = [...this.commodities, {
                ...this.commodityForm,
                isHazmat: this.serviceInfo.isHazmat,
                ...(this.serviceInfo.isHazmat && {
                    hazmatDetails: {
                        quantity: this.serviceInfo.hazmatQty,
                        class: this.serviceInfo.hazmatClass,
                        packingGroup: this.serviceInfo.packingGroup,
                        code: this.serviceInfo.hazmatCode,
                        contactName: this.serviceInfo.hazmatContactName,
                        contactPhone: this.serviceInfo.hazmatContactPhone
                    }
                })
            }];
            this.$emit('input', newCommodities);

            this.isResettingForm = true;

            // reset fields
            this.resetCommodityForm();
            this.resetHazmatFields();

            this.$emit('update:showError', false);
            this.$emit('update:missingFields', []);

            this.$nextTick(() => {
                this.isResettingForm = false;
            });

            this.formResetKey++;
        },
        deleteCommodity(index: number): void {
            this.commodityToDeleteIndex = index;
            this.showDeleteConfirmDialog = true;
        },
        editCommodity(index: number): void {
            this.editingCommodityIndex = index;
            this.showEditModal = true;
            const commodity = this.commodities[index];

            // Map the commodity data and expand hazmatDetails if present
            this.editFormCommodity = {
                ...commodity,
                // If hazmat details exist, map them to individual fields
                ...(commodity.hazmatDetails && {
                    hazmatQty: commodity.hazmatDetails.quantity,
                    hazmatClass: commodity.hazmatDetails.class,
                    packingGroup: commodity.hazmatDetails.packingGroup,
                    hazmatCode: commodity.hazmatDetails.code,
                    hazmatContactName: commodity.hazmatDetails.contactName,
                    hazmatContactPhone: commodity.hazmatDetails.contactPhone
                })
            };

            this.showEditCommodityError = false;
        },
        saveEditedCommodity(): void {
            this.showEditCommodityError = true;

            if (!this.validateEditForm()) {
                return;
            }

            if (this.editingCommodityIndex !== null) {
                const newCommodities = [...this.commodities];

                // Prepare the commodity data with proper hazmat structure
                const updatedCommodity = {
                    ...this.editFormCommodity,
                    // Remove individual hazmat fields from the top level
                    hazmatQty: undefined,
                    hazmatClass: undefined,
                    packingGroup: undefined,
                    hazmatCode: undefined,
                    hazmatContactName: undefined,
                    hazmatContactPhone: undefined,
                    // Add hazmatDetails object if hazmat is selected
                    ...(this.editFormCommodity.isHazmat && {
                        hazmatDetails: {
                            quantity: this.editFormCommodity.hazmatQty,
                            class: this.editFormCommodity.hazmatClass,
                            packingGroup: this.editFormCommodity.packingGroup,
                            code: this.editFormCommodity.hazmatCode,
                            contactName: this.editFormCommodity.hazmatContactName,
                            contactPhone: this.editFormCommodity.hazmatContactPhone
                        }
                    })
                };

                // Clean up undefined properties
                Object.keys(updatedCommodity).forEach(key => {
                    if (updatedCommodity[key] === undefined) {
                        delete updatedCommodity[key];
                    }
                });

                newCommodities[this.editingCommodityIndex] = updatedCommodity;
                this.$emit('input', newCommodities);
                this.showEditModal = false;
                this.editingCommodityIndex = null;
                this.showEditCommodityError = false;
            }
        },
        cancelDelete(): void {
            this.showDeleteConfirmDialog = false;
            this.commodityToDeleteIndex = null;
        },
        confirmDelete(): void {
            if (this.commodityToDeleteIndex !== null) {
                const newCommodities = [...this.commodities];
                newCommodities.splice(this.commodityToDeleteIndex, 1);
                this.$emit('input', newCommodities);
                this.showDeleteConfirmDialog = false;
                this.commodityToDeleteIndex = null;
            }
        },
        onEquipmentTypeChange(eq: DropdownOption) {
            this.$emit('update:equipmentType', eq.value?.toString());
        },
        onProductSelected(product) {
            const newCommodity = {
                name: product.description || '',
                pieces: 1,
                weight: product.weight || null,
                weightUnit: 'lbs',
                length: product.length || null,
                width: product.width || null,
                height: product.height || null,
                dimensionUnit: 'in',
            };
            const newCommodities = [...this.commodities, newCommodity];
            this.$emit('input', newCommodities);
            this.showProductListPopup = false;
        },
        loadHazmatDropdowns() {
            hazmatService.list().then((x) => {
                this.hazmatClasses = x.map((c: any) => new DropdownOption(c.name, c.code));
            }).catch(error => {
                console.error('Error loading hazmat classes:', error);
            });

            this.hazmatQtyTypes = hazmatService.getHazmatQtyTypes();
            this.packingGroupTypes = hazmatService.getPackingGroupTypes();
        },
        validateHazmatDetails(): boolean {
            const missingFields = [];

            if (!this.serviceInfo.hazmatQty) missingFields.push('Hazmat Quantity');
            if (!this.serviceInfo.hazmatClass) missingFields.push('Hazmat Class');
            if (!this.serviceInfo.packingGroup) missingFields.push('Package Group');
            if (!this.serviceInfo.hazmatCode) missingFields.push('Hazmat Code');
            if (!this.serviceInfo.hazmatContactName) missingFields.push('Contact Name');
            if (!this.serviceInfo.hazmatContactPhone) missingFields.push('Contact Phone');

            if (missingFields.length > 0) {
                this.$emit('update:missingFields', missingFields);
                this.$emit('update:showError', true);
                return false;
            } else {
                this.$emit('update:showError', false);
                return true;
            }
        },
        resetHazmatFields(): void {
            this.serviceInfo = {
                isHazmat: false,
                hazmatQty: null,
                hazmatClass: null,
                packingGroup: null,
                hazmatCode: '',
                hazmatContactName: '',
                hazmatContactPhone: ''
            };
        },
        resetCommodityForm(): void {
            this.commodityForm = {
                name: '',
                pieces: null,
                weight: null,
                weightUnit: 'lbs',
                length: null,
                width: null,
                height: null,
                dimensionUnit: 'in',
            };
        },
    }
});
